import {
  MEDIA_ENTRY_APPLICATION,
  MEDIA_ENTRY_CONTENT_GROUP,
  MEDIA_ENTRY_FOLDER,
  MEDIA_ENTRY_USER_CONTENT,
  MEDIA_ENTRY_WEBPAGE,
  MEDIA_TABLE_FILTER_FOLDER,
  MEDIA_TABLE_FILTER_TAG,
  MEDIA_TABLE_FILTER_TYPE,
} from "fleet/constant/media-library";
import { ConnectedAddWebPageForm } from "fleet/controller/media-library/connected-add-web-page-form";
import { ConnectedAddSpotMediaTable } from "fleet/controller/strategy-v2/connected-add-spot-media-table";
import PropTypes from "prop-types";
import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Features } from "ui/features";

import { PropTypePriorities } from "./utils";

class AddSpot extends React.PureComponent {
  static get propTypes() {
    return {
      defaultActiveTab: PropTypes.oneOf(["applications", "media", "web-page"]),
      priority: PropTypePriorities.isRequired,
      validContentTypes: PropTypes.array,
    };
  }

  static get defaultProps() {
    return {
      defaultActiveTab: "media",
    };
  }

  render() {
    const { defaultActiveTab, validContentTypes, priority } = this.props;

    return (
      <div className="upload-media">
        <Tabs
          defaultActiveKey={defaultActiveTab}
          className="nav-tabs-custom tabbed-incidents-table"
          animation={false}
          id="tabbed-incidents-table"
        >
          <Tab eventKey="media" title="Media">
            <ConnectedAddSpotMediaTable
              priority={priority}
              filterFields={[
                MEDIA_TABLE_FILTER_TYPE,
                MEDIA_TABLE_FILTER_TAG,
                MEDIA_TABLE_FILTER_FOLDER,
              ]}
              includeMediaTypes={[
                MEDIA_ENTRY_FOLDER,
                MEDIA_ENTRY_USER_CONTENT,
                MEDIA_ENTRY_CONTENT_GROUP,
              ]}
            />
          </Tab>
          {validContentTypes.includes(MEDIA_ENTRY_APPLICATION) && (
            <Tab eventKey="applications" title="Applications">
              <ConnectedAddSpotMediaTable
                priority={priority}
                includeMediaTypes={[MEDIA_ENTRY_APPLICATION]}
                excludeColumns={["tag", "friendlyType"]}
              />
            </Tab>
          )}
          {Features.isEnabled(Features.constants.STRATEGIES_V2_WEBPAGES) &&
            validContentTypes.includes(MEDIA_ENTRY_WEBPAGE) && (
              <Tab eventKey="web-page" title="Web Page">
                <ConnectedAddWebPageForm priority={priority} />
              </Tab>
            )}
        </Tabs>
      </div>
    );
  }
}

export { AddSpot };
